import styles from "./CheckBox.module.scss";
import CheckIcon from "@mui/icons-material/Check";
import { checkIconStyles } from "./CheckBox.styles";

interface CheckBoxProps {
  checked: boolean;
  toggleChecked: () => void;
  label?: string;
  labelSide?: "left" | "right";
  additionalPadding?: boolean;
}

function CheckBox(props: CheckBoxProps) {
  const {
    checked,
    toggleChecked,
    label,
    labelSide = "left",
    additionalPadding,
  } = props;

  return (
    <div
      className={`${styles.checkboxWrapper} ${
        additionalPadding ? styles.additionalPadding : ""
      }`}
    >
      {label && labelSide === "left" && (
        <p className={`body-medium ${styles.checkboxLabel}`}>{label}</p>
      )}
      <div
        className={`${styles.checkbox} ${checked ? styles.checked : ""}`}
        onClick={toggleChecked}
      >
        {checked && <CheckIcon sx={checkIconStyles} />}
      </div>
      {label && labelSide === "right" && (
        <p className={`body-medium ${styles.checkboxLabel}`}>{label}</p>
      )}
    </div>
  );
}

export default CheckBox;
